import { useTranslation } from "react-i18next";
import useStyles from "./styles";
import { getCurrency } from "../../../../utils/constant";

interface Props {
  currentImport: number;
  currentExport: number;
  currency: string;
}

const ImportExportRates = (props: Props) => {
  const classes = useStyles();
  const { currentImport, currentExport, currency } = props;
  const { t } = useTranslation();
  const currencySymbol = getCurrency(currency);

  if (currentExport == null) return null;

  return (
    <div className={classes.container}>
      <div>
        <div className={classes.title}>{t("Current_Export_Rate")}</div>
        <h3>{currencySymbol}{currentExport}</h3>
        <div className={classes.subtitle}>{t("per_kWh")}</div>
      </div>
    </div>
  );
};

export default ImportExportRates;
